import React, { useEffect, useReducer, useRef, ReactNode  } from "react";

// Interface for component props
interface ModuleProps {
	title: string;
	description?: string;
	selected?: boolean;
	focused?: boolean;
	hidden?: boolean;
	onChange?: () => void;
	children?: ReactNode;
}

export const Module = ( props: ModuleProps ) => {


	return (
		<section className={"module" + (props.selected || props.focused ? "" : " module-reduced") + (props.hidden ? " hidden" : "") } >

			<p className={"module-title"}>
				<span className={"module-title-head"} onClick={ props.onChange }>{ props.title }</span>
				<span className={"module-title-subhead" +(props.description == null ? "hidden":"")}>{ props.description }</span>
			</p>

			<div className={"module-content"}>
				{
					props.children
				}
			</div>

		</section>
	);
};